import { createAction } from '../../store/createAction';

export const cancelRequestIds = createAction<string[]>('request/CANCEL_REQUEST_IDS');
